// import React from 'react';

import { useEffect } from 'react';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const Toast = ({ successMessage, position, type, toastId, handleClose }: any) => {
  useEffect(() => {
    toast.success(successMessage, {
      position: position === 'topRight' ? toast.POSITION.TOP_RIGHT : toast.POSITION.TOP_CENTER,
      type: type === 'error' ? toast.TYPE.ERROR : toast.TYPE.SUCCESS,
      toastId,
      onClose: handleClose,
      autoClose: 3000,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successMessage, position, type, toastId]);
  return null;
};

export default Toast;
